module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_1.c18b3b25.png";